<template>
  <div>
    <slot :options="options"></slot>
  </div>
</template>

<script>
import options from '@views/question-editor/utils/options'

export default {
  components: {},
  provide () {
    return {
      SjQuestionOption: this,
    }
  },
  props: {
    model: Array,
  },
  data () {
    return {}
  },
  computed: {
    options () {
      return this.model
    },
  },
  watch: {},
  created () {},
  mounted () {},
  destroyed () {},
  methods: {
    /**
     * 添加题目
     *
     * @param data
     * @param type
     * @param toIndex
     */
    add (data, type, toIndex) {
      // 复制到指定位置
      !Number.isInteger(toIndex) && (toIndex = data.length)
      options.create(data, type, toIndex)
    },
  },
  filters: {},
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/question-editor/packages/sj-question-option/src/SjQuestionOption.vue